import React from 'react';
import PropTypes from 'prop-types';
import { Link as CLink } from '@chakra-ui/react';

const PopoverLink = ({ label, onClick = () => null }) => {
  return (
    <CLink
      _focus={{ boxShadow: 'none ' }}
      width={'100%'}
      textAlign={'left'}
      py={2}
      px={2}
      _hover={{ bg: '#11284B', color: '#fff', textDecoration: 'none' }}
      onClick={() => onClick()}
    >
      {label}
    </CLink>
  );
};

PopoverLink.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default PopoverLink;



// WEBPACK FOOTER //
// src/components/layout/PopoverLink/PopoverLink.jsx